import {Link, useLocation} from 'react-router-dom'
import { fleurSVGBlack } from '../../../../utils/constants'
import SVG from 'react-inlinesvg'

type MessageState = {
  title?: string
  body?: string
  ctaText?: string
  ctaTo?: string
  classNameBtn?: string | null
  showBtn?: boolean
  color?: string
}

export function MessageComponent() {
  const {state} = useLocation<MessageState>()
  const {
    title = '',
    body = 'Our review process may take up to 30 days. Please note that we may request additional documentation to support your eligibility, if needed.',
    ctaText = 'LOGIN',
    ctaTo = '/auth/login',
    classNameBtn = null,
    showBtn = true,
    color,
  } = state || {}

  return (
    <div className='w-100 p-5'>
      {/* begin::Heading */}
      <div className='text-center mb-2'>
        <h2 className='nb-heading-h2 nb-text-center' style={{whiteSpace: 'pre-line'}}>{title}</h2>
      </div>
      {/* begin::Heading */}
      <div className='text-center '>
        <div className='nb-body nb-center nb-muted'>{body}</div>

        <div className='nb-divider my-6 mb-10' aria-hidden='true'>
          <span className='nb-divider__line' />
          <span className='nb-divider__icon'>
            <SVG src={fleurSVGBlack} />
          </span>
          <span className='nb-divider__line' />
        </div>
      </div>
      {/* begin::Action */}

      {showBtn ? (
        <div className='text-center mt-3'>
          <Link
            to={ctaTo}
            className={`btn w-100 mb-5 ${classNameBtn ? 'nb-btn-outline' : 'nb-btn-primary'}`}
          >
            <span className='nb-heading-md'> {ctaText}</span>

            <img
              src='/media/svg/nobilis/vector1.svg'
              alt=''
              /* className='nb-btn-icon nb-btn-icon--black' */
              className={`nb-btn-icon nb-btn-icon--${color == 'W' ? 'black' : 'white'}`}
            />
          </Link>
        </div>
      ) : null}

      {/* end::Action */}
    </div>
  )
}
